/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/calculator'
export default icon
